import { Box, Button, Grid, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import { portalAction, portalScreenContext } from '../../../app/telemetry/portalTelemetry';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import AppDatePicker from '../../../app/components/AppDatePicker';
import AppCheckboxFieldWithLeftAlignedLabel from '../../../app/components/AppCheckboxFieldWithLeftAlignedLabel';
import AppSlider from '../../../app/components/AppSlider';
import AppTextareaInput from '../../../app/components/AppTextareaInput';
import AppAutocomplete from '../../../app/components/AppAutocomplete';
import { MESSAGE_PROCESSING_DETAILS } from '../../../app/utils/constant';
import { AppPathEnum } from '../../../app/enums/appPathEnum';
import cpdFormModel from './cpdFormModel';
import RestrictCpdUpdateDialog from './RestrictCpdUpdateDialog';
import CpdCategoryIntroduction from './CpdCategoryIntroduction';
import { CpdFormMode, cpdFormConfig } from './cpdFormConfig';
import { useCpdForm } from './useCpdForm';

export default function CpdForm({ mode }: { mode: CpdFormMode }) {
    const { ActivityDate, Category, ActivityType, Domains, CreditsClaiming, Description, DevelopmentPurpose } = cpdFormModel.formField;
    const {
        control, creditRecordId, filteredActivityTypes, categoryItems, domainOptions,
        isLoading, showRestrictionDialog, dialogDescription, onCloseDialog, onSubmit
    } = useCpdForm(mode);
    
    const { minimumCredits } = cpdFormConfig[mode];
    const screen = portalScreenContext(mode + 'CpdForm');

    if (isLoading) return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />;

    if (showRestrictionDialog) {
        return <RestrictCpdUpdateDialog showDialog={showRestrictionDialog}
            closeButtonClick={portalAction(screen, mode + 'CpdForm.closeButtonClick.onCloseDialog', onCloseDialog)}
            title='Update not allowed.' description={dialogDescription} />;
    }

    return <Box sx={{ width: '100%' }} component={Paper}>

        <CpdCategoryIntroduction mode={mode} />

        <Grid container rowSpacing={4} sx={{ marginLeft: '2%', marginTop: '1%' }}>

            <Grid size={{ xs: 12 }}>
                <AppDatePicker control={control} name={ActivityDate.name} maxDate={new Date()}
                    minDate={new Date(2025, 4, 1)} label={ActivityDate.label} defaultValue={null}
                    information_text={ActivityDate.informationText} />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <AppAutocomplete control={control} name={Category.name} label={Category.label}
                    items={categoryItems}
                    information_text={Category.informationText} />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <AppAutocomplete control={control} name={ActivityType.name} label={ActivityType.label}
                    items={filteredActivityTypes} information_text={ActivityType.informationText} />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <AppCheckboxFieldWithLeftAlignedLabel control={control} name={Domains.name}
                    label={Domains.label} options={domainOptions}
                    information_text={Domains.informationText} />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <AppSlider control={control} label={CreditsClaiming.label} name={CreditsClaiming.name}
                    defaultValue={minimumCredits} step={0.5} min={minimumCredits} max={40}
                    information_text={CreditsClaiming.informationText} />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <AppTextareaInput control={control} name={Description.name} label={Description.label}
                    information_text_with_textarea={Description.informationText} maxStringCount={Description.maxStringCount} />
            </Grid>

            <Grid size={{ xs: 12 }}>
                <AppTextareaInput control={control} name={DevelopmentPurpose.name} label={DevelopmentPurpose.label}
                    information_text_with_textarea={DevelopmentPurpose.informationText} maxStringCount={DevelopmentPurpose.maxStringCount} />
            </Grid>

            <Grid size={{ xs: 11 }} sx={{ display: 'flex', justifyContent: 'end' }}>
                {mode !== 'Add' && <Button variant="outlined" component={Link}
                    to={AppPathEnum.PCS_VIEW_CPD + '/' + creditRecordId} sx={{ mt: 3, ml: 1 }}
                    onClick={portalAction(screen, mode + 'CpdForm.navigate', () => { })}>Cancel</Button>}
                <Button variant="contained" type='submit' sx={{ mt: 3, ml: 1 }}
                    onClick={portalAction(screen, mode + 'CpdForm.onClick.handleSubmit', onSubmit)}>Submit</Button>
            </Grid>

            <Grid size={{ xs: 1 }}></Grid>

            <Grid size={{ xs: 12 }}></Grid>

        </Grid>
    </Box>
}
